import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Create new user entity
     * @param requestBody
     * @returns UserBOInterface
     * @throws ApiError
     */
    static userCreateUser(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update user entity
     * @param userId
     * @param requestBody
     * @returns UserBOInterface
     * @throws ApiError
     */
    static userUpdateUser(userId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get user entity by Firebase uid
     * @param userFid
     * @returns UserBOInterface
     * @throws ApiError
     */
    static userGetUserByFirebaseId(userFid) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/{userFid}',
            path: {
                'userFid': userFid,
            },
        });
    }
    /**
     * Add to user entity's signedTermsOfService array
     * @param userId
     * @param version
     * @returns boolean
     * @throws ApiError
     */
    static userSignTermsOfService(userId, version) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/{userId}/tos/{version}',
            path: {
                'userId': userId,
                'version': version,
            },
        });
    }
}
